export const BRAND = {
  name: "LifeIQ",
  tagline: "Because marks alone won't run life.",
  city: "Hyderabad",
  email: "education@lifeiq.in",
  phone: "+91 91210 01100",
};

export const NAV = [
  { label: "The Program", href: "/the-program" },
  { label: "Three Levels", href: "/#levels" },
  { label: "Philosophy", href: "/philosophy" },
  { label: "Cyber Safety", href: "/cyber-safety" },
  { label: "Books", href: "/books" },
  { label: "For Schools", href: "/for-schools" },
  { label: "For Parents", href: "/for-parents" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];
